module.exports = __webpack_public_path__ + "img/clipper1.df691dfe.png";